var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%"},style:({'color':_vm.color})},[_c('div',{staticClass:"flex top_title"},[_vm._v(_vm._s(_vm.data.title))]),_c('div',{staticClass:"flex content"},[_vm._v(_vm._s(_vm.data.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }